import React, {
	useEffect, useState
}from "react"
import {
	 Popconfirm, Table, Pagination
}from 'antd'
import {
	reSubthemesOgulActions
}from './actions'
import {
	themesOgulActions
}from '../ReThemesOgul/actions'
import ReSubthemeOgulChangeForm from "./ReSubthemeOgulChangeForm"
import {
	useDebounce
}from 'use-lodash-debounce'
import {
	useDispatch,
	useSelector
}from 'react-redux'
import 'antd/lib/date-picker/style/index.css'
import i18nGlobal from "../../../localization"
import CustomButton from "../../../components/ButtonCustom"
import {
	CustomInput
}from "../../../components/CustomInput"
import i18n from "../localization"
import Notifications from "../../../helpers/Notifications"
import LoadingComponent from '../../../components/Loading/Local'
import CRUDIcons from "../../../components/CRUDIcons/index"

const ReSubthemesOgul = (props) => {//'Подтемы обращений граждан и юридических лиц'
	const isRu = useSelector(state => state.globalReducer.isRu)
	const [countSubthemesOgul, setCountSubthemesOgul] = useState('')
	const [table, setTable] = useState([])
	const [page, setPage] = useState(1)
	const [themes, setThemes] = useState([])
	const pageSize = 10
	const [value, setValue] = useState("")
	const searchValue = useDebounce(value, 500)
	const [allPaged, setAllPaged] = useState(false)
	const [visible, setVisible] = useState(false)
	const ThemeOgul = useSelector(state => state.reThemesOgulReducer.currentItem)
	const SubThemeOgul = useSelector(state => state.reSubthemesOgulReducer.currentItem)
	const dispatch = useDispatch()
	const [resource, setResource] = useState(null)
	const { isModify = false } = props
	const { isSending, subThemesOgulChanged } = useSelector((state) => state.reSubthemesOgulReducer)
	const getThemeOgulByName = params => {
		dispatch(themesOgulActions.getThemeOgulByName(params))
	}
	const getSubthemeByName = params => {
		dispatch(reSubthemesOgulActions.getSubthemeByName(params))
	}
	const createSubthemeOgul = params => {
		dispatch(reSubthemesOgulActions.createSubthemeOgul(params))
	}
	const deleteSubthemeOgul = params => {
		dispatch(reSubthemesOgulActions.deleteSubthemeOgul(params))
	}
	const updateSubthemeOgul = params => {
		dispatch(reSubthemesOgulActions.updateSubthemeOgul(params))
	}
	const restoreSubthemeOgul = params => {
		dispatch(reSubthemesOgulActions.restoreSubthemeOgul(params))
	}

	function onDeleteClick(id){
		deleteSubthemeOgul({ id })
	}
	function onRestoreClick(id){
		restoreSubthemeOgul({ id })
	}

	useEffect(() => {
		setPage(1)
		const name = searchValue.trim().length > 2 ? searchValue.trim() : ""
		if (!name && !allPaged){
			getSubthemeByName({
				name     : name,
				pageSize : pageSize,
				page     : 1
			})
			setAllPaged(true)
		}
		if (name){
			getSubthemeByName({
				name     : name,
				pageSize : pageSize,
				page     : 1
			})
			setAllPaged(false)
		}
	}, [searchValue])
	useEffect(() => {
		const items = ThemeOgul.items
		if (items){
			const temp = []
			items.forEach((value) => {
				if (!value.isDeleted){
					temp.push({
						code    : value.code,
						name    : value.name,
						nameBel : value.nameBel,
						id      : value.id
					})
				}
			})
			setThemes(temp)
		}
	}, [ThemeOgul.items])

	useEffect(() => {
		if (subThemesOgulChanged){
			Notifications.successNotice(subThemesOgulChanged, "", 15)
			onPaginationChange(page)
		}
	}, [subThemesOgulChanged])

	  useEffect(() => {
	  	getThemeOgulByName({
	  		name     : '',
	  		page     : 1,
	  		pageSize : 1000
	  	})
		  return () => {
			dispatch(themesOgulActions.clearThemeOgul())
			dispatch(reSubthemesOgulActions.clear())
			setThemes([])
		}
	  }, [])

	useEffect(() => {
		const items = SubThemeOgul.items
		if (items){
			const temp = []
			items.forEach((value, index) => {
				const startDate = new Date(value.startDate).toLocaleDateString('ru-RU')
				let endDate = new Date(value.endDate).toLocaleDateString('ru-RU')
				if (endDate === '01.01.1970')
					endDate = ''

				temp.push({
					id          : value.id,
					code        : value.code,
					name        : value.name,
					nameBel     : value.nameBel,
					themeOgulId : value.themeOgulId,
					startDate   : startDate,
					endDate     : endDate,
					rowKey      : index,
					isDeleted   : value.isDeleted,
					change      : value.id,
					delete      : value.id
				})
			})
			setCountSubthemesOgul(SubThemeOgul.count)
			setTable(temp)
		}
	}, [SubThemeOgul.items])

	function showModal(id){
		const item = table.find((value) => {
			return value.id === id
		})
		setResource(item)
		setVisible(true)
	}
	function onPaginationChange(value){
		setPage(value)
		getSubthemeByName({
			name     : searchValue.trim().length > 2 ? searchValue.trim() : "",
			pageSize : pageSize,
			page     : value
		})
	}

	const columns = [
		{
			title     : i18n.tableHeaderCode[isRu],
			inputType : "text",
			dataIndex : 'code',
			editable  : false,
			key       : 'code'
		},
		{
			title     : i18n.tableHeaderNameRu[isRu],
			inputType : "text",
			dataIndex : 'name',
			editable  : false,
			key       : 'name'
		},
		{
			title     : i18n.tableHeaderNameBel[isRu],
			inputType : "text",
			dataIndex : 'nameBel',
			editable  : false,
			key       : 'nameBel'
		},
		{
			title     : i18n.tableHeaderDateStart[isRu],
			inputType : "text",
			dataIndex : 'startDate',
			editable  : false,
			key       : 'startDate'
		},
		{
			title     : i18n.tableHeaderDateEnd[isRu],
			inputType : "text",
			dataIndex : 'endDate',
			editable  : false,
			key       : 'endDate'
		}
	]
	isModify
		? columns.push({
			dataIndex : "change",
			key       : 'update',
			width     : 100,
			render    : (id, record) => (
				<>
					<div>
						{CRUDIcons.update((e) => {
							e.stopPropagation()
							showModal(id)
						})}

						{
							<Popconfirm
								cancelText={ i18nGlobal.no[isRu] }
								okText={ i18nGlobal.yes[isRu] }
								title={ !record.isDeleted ? i18n.messageChooiseDeleteItem[isRu] : i18n.messageChooiseUpdateItem[isRu] }
								onCancel={ (e) => {
									e.stopPropagation()
									return null
								} }
								onConfirm={ (e) => {
									e.stopPropagation()
									!record.isDeleted ? onDeleteClick(id) : onRestoreClick(id)
								} }
							>
								{!record.isDeleted 
								 ? CRUDIcons.delete((e) => e.stopPropagation()) 
								 : CRUDIcons.restore((e) => e.stopPropagation())}
							</Popconfirm>
						}
					</div>
				</>)
		})
		: null
	return (
		<>

			<div>
				<div className="header-admin-nsi">
					<CustomInput
						maxLength={ 64 }
						placeholder={ i18n.placeholderSearchInput[isRu] }
						onChange={ (e) => setValue(e.target.value) }
					/>
					{ isModify
						? (
							<CustomButton
								className="add-nsi"
								loading={ isSending }
								type="orange"
								onClick={ showModal }
							>
								<div>
									{CRUDIcons.create()}
									<span>
										{ i18n.buttonAdd[isRu] }
									</span>
								</div>
							</CustomButton>
						)
						:null }
				</div>
				<Table
					columns={ columns }
					dataSource={ table }
					loading={ { indicator : <LoadingComponent />,
						spinning  : isSending } }
					pagination={ false }
					scroll={ { x: 600 } }
				/>
				{
					countSubthemesOgul > pageSize &&
							(
							 <Pagination
									current={ page }
									pageSize={ pageSize }
									showSizeChanger={ false }
									total={ countSubthemesOgul }
									onChange={ onPaginationChange }
							 />
							)
				}

			</div>
			{ isModify &&
					<ReSubthemeOgulChangeForm
						create={ createSubthemeOgul }
						resource={ resource }
						setResource={ setResource }
						setVisible={ setVisible }
						themes={ themes }
						update={ updateSubthemeOgul }
						visible={ visible }
						onDeleteClick={ onDeleteClick }
						onRestoreClick={ onRestoreClick }
					/> }
		</>

	)
}

export default ReSubthemesOgul